import request from './request';

// 获取孟郎诗词集合
export const GetLangCollections = (params) => request.get("/langCollection/getCollections",{params});

// 根据collectionId获取孟郎诗词
export const GetLangPoemsByCollectionId = (params) => request.get("/langPoem/getLangPoemsByCollectionId",{params});

// 根据id获取孟郎诗词
export const GetLangPoemById = (params) => request.get("/langPoem/getLangPoemById",{params});